(function () {
    'use strict';

    angular
        .module('app')
        .controller('MergeSchoolController', MergeSchoolController);

    MergeSchoolController.$inject = ['debug', 'API', 'i18n', '$scope', '$state',];

    function MergeSchoolController(debug, API, i18n, $scope, $state) {
        var vm = this;
        vm.cancel = $scope.$parent.cancel;
        vm.resolve = $scope.$parent.resolve;
        vm.submit = submit;
        vm.loading = false;
        vm.schoolsList = [];

        activate();

        function activate() {
            loadSchools();
            vm.school = $scope.placeholders.school;
        }

        function submit() {
            API.School.mergeWith({
                id: vm.school.id,
                action: 'merge-with',
                target: vm.schoolIdToMergeWith
            }).$promise.then(function (response) {
                if (response) {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                } else {
                    window.toast({ message: i18n.get('FAILED'), type: 'danger' });
                }
                $state.go('schools.edit',{ id: vm.schoolIdToMergeWith });
                $scope.$parent.close();
            }, function () {
                window.toast({ message: i18n.get('FAILED'), type: 'danger' });
            });
        }

        function loadSchools() {
            vm.loading = true;
            API.School.search({
                'per-page': 0,
                'status': 'verified',
                'sort': 'name',
                'fields': 'id,name,disctrict'
            })
                .$promise
                .then(function (list) {
                    angular.forEach(list.items, function (school) {
                        if (school.id !== vm.school.id) {
                            vm.schoolsList.push({
                                value: school.id,
                                label: school.name,
                                subLabel: school.district,
                            });
                        }
                    });
                }, function () {
                    debug.error('Could not load schools.');
                }).finally(function() {
                    vm.loading = false;
                });
        }

    }
})();